var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EvmPriceServiceConnection } from '@pythnetwork/pyth-evm-js';
import * as viem from 'viem';
export class PythAdapter {
    constructor(endpoint) {
        this.connection = new EvmPriceServiceConnection(endpoint);
    }
    getOracleId() {
        return 'PYTH';
    }
    pepareOracleUpdates(priceIds) {
        return __awaiter(this, void 0, void 0, function* () {
            let updateData = yield this.connection.getPriceFeedsUpdateData(priceIds);
            return viem.encodeAbiParameters([
                { type: 'uint8', name: 'updateType' },
                { type: 'uint64', name: 'stalenessTolerance' },
                { type: 'bytes32[]', name: 'priceIds' },
                { type: 'bytes[]', name: 'updateData' },
            ], [1, BigInt(30), priceIds, updateData]);
        });
    }
    fetchOffchainData(_client, _requester, data, extraPriceIds = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const [updateType, stalenessTolerance, priceIds] = viem.decodeAbiParameters([
                { name: 'updateType', type: 'uint8' },
                { name: 'stalenessTolerance', type: 'uint64' },
                { name: 'priceIds', type: 'bytes32[]' },
            ], data);
            const allIds = [...new Set([...priceIds, ...extraPriceIds])];
            if (updateType !== 1) {
                throw new Error(`update type ${updateType} not supported`);
            }
            let updateData = yield this.connection.getPriceFeedsUpdateData(allIds);
            return viem.encodeAbiParameters([
                { type: 'uint8', name: 'updateType' },
                { type: 'uint64', name: 'stalenessTolerance' },
                { type: 'bytes32[]', name: 'priceIds' },
                { type: 'bytes[]', name: 'updateData' },
            ], [updateType, stalenessTolerance, allIds, updateData]);
        });
    }
}
